<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title-1"><span class="bold">Battleground Europe</span></h1>
<h1 class="title-2"><span class="bold">The Somme 1916</span></h1>
<h1 class="title">The Butte de Warlencourt</h1>
<p class="sub_heading">Martinpuich and Le Sars</p>
<p class="author1">Bob Paterson</p>
<p class="author2"><em class="italic">Series Editor</em></p>
<p class="author3">Nigel Cave</p>
<div class="img_containerj">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?4a069f0d